import React, { useState } from 'react';
import { Lock, Eye, EyeOff, Wallet } from 'lucide-react';

function AccessCode({ onAccessGranted }) {
  const [code, setCode] = useState('');
  const [showCode, setShowCode] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const accessCode = process.env.REACT_APP_ACCESS_CODE;
    if (!accessCode) {
      setError('접근 코드가 설정되지 않았습니다. 관리자에게 문의하세요.');
      return;
    }
    if (code === accessCode) {
      onAccessGranted();
    } else {
      setError('잘못된 코드입니다. 다시 시도해주세요.');
      setCode('');
    }
  };

  const toggleShowCode = () => {
    setShowCode(!showCode);
  };

  return (
    <div className="access-code-container">
      <div className="access-code-modal">
        <div className="access-code-header">
          <div className="access-code-icon">
            <Wallet size={48} />
          </div>
          <h1>Loop Budget</h1>
          <p>접근 코드를 입력하세요</p>
        </div>
        
        <form onSubmit={handleSubmit} className="access-code-form">
          <div className="code-input-container">
            <Lock size={20} className="lock-icon" />
            <input
              type={showCode ? "text" : "password"}
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setError('');
              }}
              placeholder="접근 코드 입력"
              className="code-input"
              autoFocus
            />
            <button
              type="button"
              onClick={toggleShowCode}
              className="toggle-visibility"
            >
              {showCode ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="submit-button">
            접속하기
          </button>
        </form>
        
        <div className="access-code-footer">
          <p>Finance Management Application</p>
        </div>
      </div>
    </div>
  );
}

export default AccessCode; 